import UserChartNotificationSettingsInterface from "@app/Interface/UserChartNotificationSettingsInterface";
import ThresholdType from "@app/Type/ThresholdType";

export default class UserChartNotificationSettingsModel implements UserChartNotificationSettingsInterface {
    fpu: number;
    chart: string;
    active: boolean;
    threshold_range: ThresholdType;
    threshold_value_min: number;
    threshold_value_max: number;
    threshold_display_value_min: string;
    threshold_display_value_max: string;isNew: boolean;
    enable_guardrail: boolean;
    guardrail_threshold: ThresholdType;
    guardrail_value: number;
    constructor(data?: UserChartNotificationSettingsInterface) {
        this.fpu = data?.fpu ?? 0;
        this.chart = data?.chart ?? "ash";
        this.active = data?.active ?? false;
        this.threshold_range = data?.threshold_range ?? "above";
        this.threshold_value_min = data?.threshold_value_min ?? 0;
        this.threshold_value_max = data?.threshold_value_max ?? 0;
        this.threshold_display_value_min = data?.threshold_value_min.toString() ?? "0";
        this.threshold_display_value_max = data?.threshold_value_max.toString() ?? "0";
        this.enable_guardrail = data?.enable_guardrail ?? false;
        this.guardrail_threshold = data?.guardrail_threshold ?? "above";
        this.guardrail_value = data?.guardrail_value ?? 0;

        this.isNew = false;
    }
    
    

}